import { TableCell, TableRow } from '@mui/material'
import type { ReactNode } from 'react'

import type { BidDetailRowState } from '@/features/bidding/utils/bidDetail/getRowStateClasses'
import { getRowStateSx } from '@/features/bidding/utils/bidDetail/getRowStateSx'

export type BidDetailStepRowProps = Readonly<{
  state: BidDetailRowState
  stepIndex: number
  dimmed?: boolean
  /** PTU + AG cells, when emitted by this row (first-of-PTU / first-of-AG). */
  identityCells?: ReactNode
  /** Pre-rendered data cells produced by the per-tab view. */
  dataCells: ReactNode
}>

export default function BidDetailStepRow({
  state,
  stepIndex,
  dimmed = false,
  identityCells,
  dataCells,
}: BidDetailStepRowProps) {
  return (
    <TableRow sx={getRowStateSx(state)}>
      {identityCells}
      <TableCell
        align="center"
        sx={{
          width: 120,
          color: 'text.secondary',
          opacity: dimmed ? 0.5 : 1,
        }}
      >
        {stepIndex}
      </TableCell>
      {dataCells}
    </TableRow>
  )
}
